import {
  BanknoteArrowUp,
  CheckCheck,
  CircleCheck,
  CirclePlay,
  GoalIcon,
  MessageCircle,
  MessageCircleOff,
  MessageSquare,
  MessageSquareWarning,
  MessageSquareX,
} from "lucide-react"
import { WorkflowEventEnum } from "schema"

export const EventIconMap = {
  [WorkflowEventEnum.ConversationStarted]: MessageCircle,
  [WorkflowEventEnum.ConversationAchieved]: CheckCheck,
  [WorkflowEventEnum.ConversationClosed]: MessageCircleOff,
  [WorkflowEventEnum.ConversationFailed]: MessageSquareX,
  [WorkflowEventEnum.ConversationMessageCreated]: MessageSquare,
  [WorkflowEventEnum.ConversationTicketCreated]: MessageSquareWarning,
  [WorkflowEventEnum.IssueCreated]: MessageSquareWarning,
  [WorkflowEventEnum.ConversationGoalAchieved]: GoalIcon,
  [WorkflowEventEnum.UpsellOpportunity]: BanknoteArrowUp,
  [WorkflowEventEnum.CapabilityEvaluated]: CircleCheck,
  [WorkflowEventEnum.CapabilityExecuted]: CirclePlay,
}
